import InventoryApi from "@/Api/InventoryApi";
import EditTableCheck from "@/Common/Table/EditTableCheck";
import { numProps, strProps } from "@/Common/Table/column";
import { ColumnType } from "@/Common/Table/type";
import { Inventory } from "@/Models/Tables/Inventory";
import { ViewInventory } from "@/Models/Views/ViewInventory";
import { useMemo } from "react";
import Add from "./Add";
import { toYMD, toYMDHMS } from "@/Common/date";
import { getUploadFlagNames } from "@Models/Enums/UploadFlag";
import EditTable from "@/Common/Table/EditTable";

function getColumns(): ColumnType<ViewInventory>[] {
    return [
        numProps("id", "Id", 60, true),
        strProps("warehouseName", "库房", 120, true, true),
        strProps("lanewayName", "巷道", 120, true, true),
        strProps("slotCode", "储位", 120, true, true),
        strProps("goodsName", "物品名称", 120, true, true),
        strProps("standard", "规格", 150, true, true),
        numProps("exportQuantity", "数量", 60, true),
        strProps("exportStockCode", "条码", 150, true, true),
        strProps("userName", "盘点人", 150, true, true),
        numProps("time", "盘点时间", 160, true, toYMDHMS),
        strProps("remark", "备注", 80, true, true),
    ];
}

export default Index;
function Index() {
    const columns = useMemo(getColumns, []);
    return <EditTable< ViewInventory> getData={InventoryApi.getViews}
        baseColumns={columns}
        isRank
        AddDom={undefined as any}
        updDataHandle={null as any}
        delDataHandle={(s: { id: number; }) => null as any}
        updMerge={updMerge}
        addDataHandle={null as any}
        editCheck={(s: { id: number; }) => s.id !== 0}
        rowKey={"id"}
    />;
}

function updMerge(source: Inventory, target: ViewInventory) {
    target.id = source.id;
    return target;
}